import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConstants } from '../../../../app-constants.service';
import { AuthService } from '../../../../services.module/auth.service';
import { ConfirmationObservable, MessageObservable } from '../../../../services.module/message.observable';
import { MeineDatenComponent } from '../meine-daten/meinedaten.component';
import { ConfigurationApiService } from '../../../../../generated/api/configuration/configuration.service';
import { UserApiService } from '../../../../../generated/api/user/user.service';
import { UserService } from '../../../../providers.module/user.service';

@Component({
    selector: 'meinedaten-vm',
    templateUrl: '../meine-daten/meinedaten.component.html',
    styleUrls: ['../../../commonless/content.less', '../../../commonless/meine-daten.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MeineDatenVmComponent extends MeineDatenComponent {

    override modify: string;

    override iAmVermittler = true;

    constructor(
        protected override readonly authService: AuthService,
        protected override readonly route: ActivatedRoute,
        protected override readonly appConstants: AppConstants,
        protected override readonly confirmationHandler: ConfirmationObservable,
        protected override readonly messageHandler: MessageObservable,
        protected override readonly configurationApiService: ConfigurationApiService,
        protected override readonly userApiService: UserApiService,
        protected override readonly userService: UserService
    ) {
        super(
            authService,
            route,
            appConstants,
            confirmationHandler,
            messageHandler,
            configurationApiService,
            userApiService,
            userService
        );
    }

}
